import React, { RefObject } from 'react'
import { connect } from 'react-redux'
import { change, formValueSelector } from 'redux-form'
import { Tab, Grid } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
import { withLivedata } from 'shared'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'

import { GridContainer } from '../../shared/StyledComponents'
import FormField from '../../shared/newFormElements'

import DebitAccountField from '../shared/DebitAccountField'
import SearchAccountsButton from '../components/SearchAccountsButton'
import DebitAccountDetailsTrigger from '../shared/DebitAccountDetailsTrigger'
import DebitAccountAddButton from '../shared/DebitAccountAddButton'
import DebitTitle from '../shared/DebitTitle'
import DebitBalance from '../shared/DebitBalance'
import CreditAccountField from '../shared/CreditAccountField'
import CreditAccountDetailsTrigger from '../shared/CreditAccountDetailsTrigger'
import CreditAccountAddButton from '../shared/CreditAccountAddButton'
import CreditTitle from '../shared/CreditTitle'
import CreditBalance from '../shared/CreditBalance'
import PrintOptions from '../shared/PrintOptions'
import CommentsModal from '../CommentsModal'
import StyledFixedHeightContainer from '../components/StyledFixedHeightContainer'

import DebitAccountCCYField from '../ConvertOnAccountInCash/DebitAccountCCYField'
import CreditAccountCCYField from '../ConvertOnAccountInCash/CreditAccountCCYField'
import RateCheckboxes from '../ConvertOnAccountInCash/RateCheckboxes'
import BuyAmountA from '../ConvertOnAccountInCash/BuyAmountA'
import SellAmountB from '../ConvertOnAccountInCash/SellAmountB'
import DebitCCYTitle from '../ConvertOnAccountInCash/DebitCCYTitle'
import CreditCCYTitle from '../ConvertOnAccountInCash/CreditCCYTitle'
import CommercialCCYButton from '../ConvertOnAccountInCash/CommercialCCYButton'
import OfficalCCYButton from '../ConvertOnAccountInCash/OfficalCCYButton'
import WarningMessages from '../ConvertOnAccountInCash/WarningMessages'
import ReverseButton from '../ConvertOnAccountInCash/ReverseButton'

import { ConvertMainTabViewProps } from './partials.types'
import { CCYCommercialRates } from '../ConvertOnAccountInCash/ConvertOnAccountInCash.types'

const isOperationDate = (operDate, DocDate) =>
  LKDate.from(dateFormatter(DocDate)).instance === LKDate.from(operDate).instance

//@ts-ignore
@withLivedata(['OpenDayStatus.Open_Day_Str as OpenDayStr'])
@withConstantPermissions(['ACC_ACCOUNT_OPEN as AddAccount'])
class ConvertMainTab extends React.Component<ConvertMainTabViewProps> {
  handleOpCodeChange: any
  debitAccountSearchButtonRef: RefObject<any>
  creditAccountSearchButtonRef: any
  render() {
    const {
      form,
      CCY,
      CCYOfficalRates,
      CCYCommercialRates,
      OpCode,
      checkDebitAccountFetcherName,
      getDebitAccountViewFetcherName,
      checkCreditAccountFetcherName,
      getCreditAccountViewFetcherName,
      CashAccounts,
      OperTypeID,
      authorizing,
      inCash,
      ID,
      hash,
      OpenDayStr,
      DocDate,
      AddAccount,
    } = this.props

    return (
      <Tab.Pane>
        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_docno')}
              </Grid.Column>

              <Grid.Column width={2}>
                {/* @ts-ignore */}
                <FormField disabled={authorizing} autoFocus name="DocNo" />
              </Grid.Column>

              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_entrydate')}
              </Grid.Column>

              <Grid.Column width={2}>
                {/* @ts-ignore */}
                <FormField
                  disabled={authorizing}
                  type="date"
                  name="DocDate"
                  customOnChange={(value) => {
                    if (!isOperationDate(OpenDayStr, value)) {
                      this.props.unCheckRates()
                    } else if (value !== DocDate && isOperationDate(OpenDayStr, value)) {
                      this.props.resetForm()
                    }
                  }}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2}>
                <DebitAccountCCYField
                  disabled={authorizing}
                  CashAccounts={CashAccounts}
                  change={this.props.change}
                  form={form}
                  CCY={CCY}
                  inCash={inCash}
                />
              </Grid.Column>

              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_debit')}
              </Grid.Column>

              <Grid.Column width={2} verticalAlign="middle">
                <DebitAccountField
                  disabled={OperTypeID === 7 || authorizing}
                  FormName={form}
                  searchAccountsFetcherName={checkDebitAccountFetcherName}
                  debitAccountSearchButtonRef={this.debitAccountSearchButtonRef}
                  isRequired
                />
              </Grid.Column>

              <div className="u-flexCenter">
                <SearchAccountsButton
                  innerRef={(ref) => {
                    this.debitAccountSearchButtonRef = ref
                  }}
                  FormName={form}
                  modalName="SearchDebitAccounts"
                  disabled={OperTypeID === 7 || authorizing}
                  ccyName="debitCCY"
                  accNo="DebitAccNo"
                  titleUNI="DebitTitleUNI"
                  accID="DebitAccID"
                  accHash="DebitAccHash"
                  accBalance="DebitAccBalance"
                  chosenAccNo="DebitChosenAccNo"
                  page="searchprefix"
                />

                <DebitAccountDetailsTrigger FormName={form} />

                <DebitAccountAddButton
                  disabled={OperTypeID === 7 || authorizing || !AddAccount}
                  FormName={form}
                  fetcherName={getDebitAccountViewFetcherName}
                  formValue="debitCCY"
                />
              </div>

              <Grid.Column width={6} textAlign="center" verticalAlign="middle">
                <DebitTitle FormName={form} />
              </Grid.Column>

              <Grid.Column verticalAlign="middle" className="u-fluid">
                <DebitBalance FormName={form} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={2}>
                <CreditAccountCCYField
                  disabled={authorizing}
                  CashAccounts={CashAccounts}
                  change={this.props.change}
                  form={form}
                  CCY={CCY}
                  inCash={inCash}
                />
              </Grid.Column>

              <Grid.Column width={2} textAlign="right" verticalAlign="middle">
                {translate('frm_acc_entry_add-lbl_credit')}
              </Grid.Column>

              <Grid.Column width={2} verticalAlign="middle">
                <CreditAccountField
                  disabled={OperTypeID === 7 || authorizing}
                  FormName={form}
                  searchAccountsFetcherName={checkCreditAccountFetcherName}
                  creditAccountSearchButtonRef={this.creditAccountSearchButtonRef}
                  isRequired
                />
              </Grid.Column>

              <div className="u-flexCenter">
                <SearchAccountsButton
                  innerRef={(ref) => {
                    this.creditAccountSearchButtonRef = ref
                  }}
                  FormName={form}
                  disabled={OperTypeID === 7 || authorizing}
                  modalName="SearchCreditAccounts"
                  ccyName="creditCCY"
                  accNo="CreditAccNo"
                  titleUNI="CreditTitleUNI"
                  accID="CreditAccID"
                  accHash="CreditAccHash"
                  accBalance="CreditAccBalance"
                  chosenAccNo="CreditChosenAccNo"
                  page="searchprefix"
                />

                <CreditAccountDetailsTrigger FormName={form} />

                <CreditAccountAddButton
                  disabled={OperTypeID === 7 || authorizing || !AddAccount}
                  FormName={form}
                  fetcherName={getCreditAccountViewFetcherName}
                  formValue="creditCCY"
                />
              </div>

              <Grid.Column width={6} textAlign="center" verticalAlign="middle">
                <CreditTitle FormName={form} />
              </Grid.Column>

              <Grid.Column verticalAlign="middle" className="u-fluid">
                <CreditBalance FormName={form} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column width={3} textAlign="center" verticalAlign="middle">
                <StyledFixedHeightContainer className="u-flexCenter">
                  {translate('frm_acc_conv_add-lbl_amount_a')}
                </StyledFixedHeightContainer>

                <StyledFixedHeightContainer className="u-flexCenter">
                  {translate('frm_acc_conv_add-lbl_amount_b')}
                </StyledFixedHeightContainer>
              </Grid.Column>

              <Grid.Column width={1} textAlign="right" verticalAlign="middle">
                <StyledFixedHeightContainer className="u-flexCenter">
                  {/* @ts-ignore */}
                  <FormField
                    name="buyACheck"
                    disabled={authorizing}
                    customOnChange={(checked: boolean) => {
                      if (checked) {
                        this.props.change('sellBCheck', '0')
                      } else {
                        this.props.change('sellBCheck', '1')
                        this.props.change('alreadyDefinedRates', '1')
                      }
                    }}
                    type="checkbox"
                  />
                </StyledFixedHeightContainer>

                <StyledFixedHeightContainer className="u-flexCenter">
                  {/* @ts-ignore */}
                  <FormField
                    name="sellBCheck"
                    disabled={authorizing}
                    customOnChange={(checked: boolean) => {
                      if (checked) {
                        this.props.change('buyACheck', '0')
                      } else {
                        this.props.change('buyACheck', '1')
                        this.props.change('alreadyDefinedRates', '1')
                      }
                    }}
                    type="checkbox"
                  />
                </StyledFixedHeightContainer>
              </Grid.Column>

              <Grid.Column width={2}>
                <BuyAmountA
                  //@ts-ignore
                  inCash={inCash}
                  CCYOfficalRates={CCYOfficalRates}
                  disabled={authorizing}
                  FormName={form}
                  change={this.props.change}
                  OperTypeID={OperTypeID}
                />

                {/* @ts-ignore */}
                <SellAmountB
                  inCash={inCash}
                  disabled={authorizing}
                  FormName={form}
                  change={this.props.change}
                  OperTypeID={OperTypeID}
                />
              </Grid.Column>

              <Grid.Column width={1}>
                <DebitCCYTitle FormName={form} />
                <CreditCCYTitle FormName={form} />
              </Grid.Column>

              <Grid.Column textAlign="center" verticalAlign="middle" width={1}>
                <ReverseButton disabled={authorizing} FormName={form} change={this.props.change} />
              </Grid.Column>

              {/* @ts-ignore */}
              <RateCheckboxes
                change={this.props.change}
                disabled={authorizing}
                CCYOfficalRates={CCYOfficalRates}
                CCYCommercialRates={CCYCommercialRates}
                FormName={form}
              />
              <Grid.Column width={1} textAlign="right">
                &nbsp;
              </Grid.Column>

              <Grid.Column width={4} textAlign="right">
                <CommercialCCYButton disabled={authorizing} FormName={form} change={this.props.change} />

                <OfficalCCYButton disabled={authorizing} FormName={form} change={this.props.change} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <GridContainer>
          <Grid>
            <Grid.Row>
              <Grid.Column verticalAlign="middle" width={8}>
                <WarningMessages FormName={form} />
              </Grid.Column>

              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                {translate('frm_acc_entry_add-lbl_opcode')}
              </Grid.Column>

              <Grid.Column width={6}>
                {/* @ts-ignore */}
                <FormField
                  disabled={authorizing}
                  name="OpCodeID"
                  customOnChange={this.handleOpCodeChange}
                  type="select"
                  options={OpCode}
                  search
                />
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                {translate('frm_acc_entry_add-lbl_purpose')}
              </Grid.Column>

              <Grid.Column className="u-fluid">
                {/* @ts-ignore */}
                <FormField disabled={authorizing} name="Comment" maxLength="300" />
              </Grid.Column>

              <CommentsModal
                disabled={authorizing}
                OperTypeID={OperTypeID}
                onRowChoose={(row) => this.props.change('Comment', row.Title)}
              />
            </Grid.Row>
          </Grid>
        </GridContainer>

        <hr />

        <PrintOptions
          FormName={form}
          change={this.props.change}
          OID={this.props.OID}
          OIDHash={this.props.OIDHash}
          ID={ID}
          hash={hash}
          OperTypeID={OperTypeID}
        />
      </Tab.Pane>
    )
  }
}

export default connect(
  (state, { form }: { form: string }) => ({
    DocDate: formValueSelector(form)(state, 'DocDate'),
    creditCCY: formValueSelector(form)(state, 'creditCCY'),
    debitCCY: formValueSelector(form)(state, 'debitCCY'),
  }),
  (dispatch, { form, CCYCommercialRates }: { form: string; CCYCommercialRates: CCYCommercialRates[] }) => ({
    unCheckRates: () => {
      dispatch(change(form, 'alreadyDefinedRates', '0'))
      dispatch(change(form, 'ccyBuyRate', '0'))
      dispatch(change(form, 'ccySellRate', '0'))
      dispatch(change(form, 'buyAmountA', '0'))
      dispatch(change(form, 'sellAmountB', '0'))
    },
    resetForm: () => {
      const ccyRatesInfo1 = CCYCommercialRates.find((rate) => rate.CCY === 'GEL' && rate.CCY2 === 'USD') || {}
      const ccyRatesInfo2 = CCYCommercialRates.find((rate) => rate.CCY === 'USD' && rate.CCY2 === 'GEL') || {}

      dispatch(change(form, 'alreadyDefinedRates', '1'))
      //@ts-ignore
      dispatch(change(form, 'ccyBuyRate', ccyRatesInfo2.RateBuy))
      //@ts-ignore
      dispatch(change(form, 'ccySellRate', ccyRatesInfo1.RateSell))
      dispatch(change(form, 'buyACheck', '1'))
      dispatch(change(form, 'sellBCheck', '0'))
      dispatch(change(form, 'buyAmountA', '0'))
      dispatch(change(form, 'sellAmountB', '0'))
    },
  }),
)(ConvertMainTab)
